import { useMutation } from '@tanstack/react-query';

import createEncryptPassword from './createEncryptPassword';

export default function useEncryptPassword() {
  return useMutation({
    mutationKey: ['use-encrypt-password'],
    mutationFn: async ({ password, token }) => {
      return await createEncryptPassword({ key: password, token });
    },
  });
}
